module.exports = __webpack_public_path__ + "static/media/home.f6c4dea8.png";